var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSimpleIllustrationSmartscan = function SvgSimpleIllustrationSmartscan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.296 75.977 4.793-2.203 4.664 2.854 5.185-2.725 5.186 2.854 4.277-2.461 5.186 2.46 4.277-2.982 4.664 2.461s-1.037-8.683-1.037-9.592c0-.908 2.203-25.271 1.945-30.715-.257-5.443-1.945-15.943-1.945-15.943l-5.314 2.59-5.702-2.725-4.02 2.332-5.964-2.724-3.627 2.724-5.572-2.853-3.627 3.24-5.186-2.461s2.725 8.941 1.946 19.57c-.78 10.63-2.725 30.586-.13 36.294v.005Z",
    fill: "#E5FAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.269 9.426H19.903M19.903 9.555v10.366M65.002 9.426h10.372M75.374 9.555v10.366M30.269 86.349H19.903M19.903 86.22V75.847M65.002 86.349h10.372M75.374 86.22V75.847",
    stroke: "#008C59",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.421 19.75c5.83 11.462-2.525 47.116 1.553 56.878M66.304 19.75c5.83 11.462-2.526 47.116 1.552 56.878",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m28.974 76.628 5.133-3.205 5.139 3.24 4.699-3.34 5.15 3.598 4.33-3.352 5.051 3.229 4.131-3.54 5.25 3.37M66.304 19.75l-5.232 2.854-5.139-3.234-4.7 3.34-5.15-3.598-4.33 3.346-5.05-3.223-4.131 3.54-5.25-3.37M35.097 30.256h2.343M41.946 30.256H57.72M59.975 30.256h2.344M34.517 67.2h2.343M41.366 67.2h15.767M59.39 67.2h2.343M35.876 39.104h23.04M35.876 48.532h23.04M36.556 58.546h10.693",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.184 46.282h-69.99v5.83h69.99v-5.83Z",
    fill: "#03D47C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.71 46.41H14.114c-.599 0-1.084.486-1.084 1.085v3.697c0 .599.485 1.084 1.084 1.084H82.71c.599 0 1.084-.485 1.084-1.084v-3.697c0-.599-.485-1.084-1.084-1.084Z",
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSimpleIllustrationSmartscan;